
import '../../assets/css/style.css';


const TarmsDan = () => {



    return (
        <>
          

            <div className="mohtava-mine">
                <section id="add-bank" className="dir-r max-cntt-w v-100">
            

                    <div className="p-35">
                        <ul>
            
<h3>
 قوانین و مقررات استفاده از نرم افزار
 </h3>

<li>
آخرین به روزرسانی: ۱۴۰۳/۱۲/۱۰</li>
<li>
با نصب و استفاده از این نرم افزار، شما با تمامی شرایط و ضوابط زیر موافقت می کنید. لطفاً این قوانین را به
دقت مطالعه نمایید.
</li>
<li>
۱. تعاریف
</li>
<li>
نرم افزار: به برنامه ای که توسط شرکت/توسعه دهنده ارائه شده است، اطلاق می شود.
</li>
<li>
کاربر: هر شخصی که نرم افزار را نصب و استفاده می کند.
توسعه دهنده: شرکت یا فردی که این نرم افزار را طراحی و منتشر کرده است.
</li>
<li>
۲. شرایط استفاده
</li>
<li>
این نرم افزار صرفاً برای استفاده قانونی طراحی شده است و کاربران نباید از آن برای فعالیت های
غیرقانونی استفاده کنند.
</li>
<li>
کاربر نباید نرم افزار را مهندسی معکوس کرده، تغییر دهد یا نسخه ای غیررسمی از آن منتشر کند.
</li>
<li>
مسئولیت حفظ اطلاعات حساب کاربری و رمز عبور بر عهده کاربر است.
</li>
<li>
۳. حقوق مالکیت فکری
</li>
<li>
کلیه حقوق مربوط به نرم افزار، شامل کد منبع، طراحی و محتوا، متعلق به توسعه دهنده است.
</li>
<li>
کاربران مجاز به استفاده شخصی از نرم افزار هستند و هرگونه توزیع، فروش یا کپی برداری بدون مجوز
ممنوع است.
</li>

<li>
۴. حریم خصوصی
</li>
<li>
اطلاعات کاربران مطابق با سیاست های حریم خصوصی نرم افزار محافظت خواهد شد.
</li>
<li>
نرم افزار ممکن است داده های مربوط به نحوه استفاده کاربران را جمع آوری کند، اما این اطلاعات بدون
رضایت کاربر به شخص ثالث ارائه نخواهد شد.
</li>

<li>
۵. محدودیت مسئولیت
</li>
<li>
توسعه دهنده هیچ گونه ضمانتی در مورد عملکرد بدون نقص نرم افزار ارائه نمی دهد.
</li>
<li>
در صورت بروز هرگونه مشکل یا آسیب ناشی از استفاده از نرم افزار، مسئولیت آن بر عهده کاربر خواهد
بود.
</li>
<li>
۶. تغییرات در قوانین
</li>
<li>
توسعه دهنده حق دارد هر زمان این شرایط را تغییر دهد و ادامه استفاده از نرم افزار به منزله پذیرش
تغییرات جدید است.
</li>
<li>
۷. ارتباط با ما
</li>
<li>
در صورت داشتن هرگونه سوال یا مشکل، می توانید با پشتیبانی نرم افزار از طریق info@doneapp.ir تماس
بگیرید.
</li>
<li>
با استفاده از این نرم افزار، شما تأیید می کنید که این شرایط را خوانده و پذیرفته اید.
</li>                   


<h3>
سیاست حفظ حریم خصوصی
 </h3>


 <li> 
 آخرین به روزرسانی: ۱۴۰۳/۱۲/۱۰
 </li> 
 <li> 
این سیاست حریم خصوصی توضیح می دهد که چگونه اطلاعات کاربران در این نرم افزار جمع آوری، استفاده و
محافظت می شود. با استفاده از نرم افزار، شما موافقت خود را با این سیاست اعلام می کنید.
</li> 
<li> 
۱. اطلاعاتی که جمع آوری می کنیم
</li> 
<li> 
ما ممکن است اطلاعات زیر را از کاربران جمع آوری کنیم:
</li> 
<li> 
اطلاعات شخصی: مانند نام، ایمیل، شماره تلفن )در صورت نیاز برای ثبت نام یا احراز هویت(.
    </li> 
    <li> 
اطلاعات فنی: مانند مدل دستگاه، سیستم عامل، آدرس IP و شناسه های نرم افزار.
</li> 
<li> 
اطلاعات استفاده: شامل نحوه تعامل شما با نرم افزار برای بهبود عملکرد و تجربه کاربری.
</li> 
<li> 
۲. نحوه استفاده از اطلاعات
</li> 
<li> 
اطلاعات جمع آوری شده ممکن است برای اهداف زیر استفاده شود:
</li> 
<li> 
ارائه، مدیریت و بهبود خدمات نرم افزار.
</li> 
<li> 
ارسال اعلان ها، به روزرسانی ها و پشتیبانی فنی.
</li> 
<li> 
تحلیل رفتار کاربران برای بهبود تجربه کاربری.
</li> 
<li> 
رعایت قوانین و مقررات مربوطه.
</li> 
<li> 
۳. اشتراک گذاری اطلاعات
</li> 
<li> 
ما اطلاعات کاربران را در شرایط زیر ممکن است با اشخاص ثالث به اشتراک بگذاریم:
</li> 
<li> 
با ارائه دهندگان خدمات: که به ما در ارائه و بهبود نرم افزار کمک می کنند )مانند میزبانی داده ها و
</li> 
<li> 
تجزیه وتحلیل عملکرد(.
مطابق قانون: در صورت درخواست مقامات قانونی یا برای محافظت از حقوق ما و کاربران.
</li> 
<li> 
با رضایت کاربر: در صورتی که کاربر اجازه اشتراک گذاری اطلاعات را بدهد.
</li> 
<li> 
۴. امنیت اطلاعات
</li> 
<li> 
ما تدابیر امنیتی مناسبی برای محافظت از اطلاعات کاربران در برابر دسترسی، تغییر یا افشای غیرمجاز اتخاذ
کرده ایم. با این حال، هیچ سیستمی به طور کامل ایمن نیست و ما نمی توانیم امنیت مطلق را تضمین کنیم.
</li> 
<li> 
۵. حقوق کاربران
</li> 
<li> 
کاربران می توانند:
</li> 
<li> 
به اطلاعات شخصی خود دسترسی داشته باشند، آنها را اصلاح کنند یا درخواست حذف آن را بدهند.
</li> 
<li> 
دریافت ایمیل های تبلیغاتی را لغو کنند.
</li> 
<li> 
از تنظیمات دستگاه خود برای محدود کردن جمع آوری برخی داده ها استفاده کنند.
</li> 
<li> 
۶. تغییرات در سیاست حریم خصوصی
</li> 
<li> 
ما ممکن است این سیاست را در هر زمان به روزرسانی کنیم. تغییرات در این صفحه منتشر خواهد شد و ادامه
استفاده از نرم افزار به منزله پذیرش تغییرات جدید است.
</li> 
<li> 
۷. تماس با ما
</li> 
<li> 
در صورت داشتن هرگونه سوال یا درخواست درباره سیاست حریم خصوصی، لطفاً با ما از طریق info@doneapp.ir تماس بگیرید.
</li> 
<li> 
با استفاده از این نرم افزار، شما تأیید می کنید که این سیاست را خوانده و پذیرفته اید.
</li> 

                       
                        </ul>

              

                    </div>

                    <div className="h-100"></div>
                </section>
            </div>
        </>
    );
};

export default TarmsDan;
